import React from "react";
import "./POVSection.css";

export default function POVSection() {
  return (
    <section className="pov">
      <div className="pov-container">
        <div className="pov-left">
          <p className="pov-label">OUR POINT OF VIEW</p>
          <h2>
            AI is not the advantage, <br />
             <span>What you build with it is.</span> <br />
          </h2>
          <div className="underline" />
        </div>




        <div className="pov-middle">
          <p>
            The next generation of winners won’t adopt AI—they’ll re-architect their enterprises around it.

          </p>
          <a href="/about/vision" className="pov-btn">
            Read Our Thinking →
          </a>
        </div>
      </div>

      {/* decorative lines */}
      <div className="pov-lines" />
    </section>
  );
}